export default {"src":"/_next/static/media/phone.a8348126.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};